import GooglePlacesAutocomplete from './GooglePlacesAutocomplete';

export default GooglePlacesAutocomplete;
